/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Drawer, ButtonGroup, Button, Grid, Typography, TextField } from '@mui/material'
import { Close, DoneAll } from '@mui/icons-material'
import LoadingButton from '@mui/lab/LoadingButton'
import { connect } from 'react-redux'
import * as organization from '../../../appRedux/actions/fuel_request/organization'
import * as field from '../../../appRedux/actions/field'
import TimePicker from '../../../components/time_picker'
import IntlMessages from '../../../util/IntlMessages'
import useStyles from './refueling.style'

function EndRequest(props) {
    const anchor = 'bottom'
    const classes = useStyles()
    const onChangeHandler = (data, field) => props.setFields([{ data, field }])

    const endRequestFunc = async () => {
        await props.completeRequestOrganizationAction(props.vRequestCode)
        props.setEndRequestFunc()
    }

    return (
        <React.Fragment>
            <Drawer
                anchor={anchor}
                open={props.endRequest}
                onClose={() => props.setEndRequestFunc()}
            >
                <Grid className={classes.root}>
                    <Grid className={classes.gridTitle}>
                        <Typography variant="h5">
                            <IntlMessages id="dearOperator" />
                        </Typography>
                        <br />
                        <Typography variant="h5">
                            <IntlMessages id="toCompleteRefuelingProcessPleaseEnterAmountReceivedFromUser(Rials)" />
                        </Typography>
                    </Grid>

                    <TextField
                        style={{ marginBottom: 20 }}
                        fullWidth
                        value={props.amount}
                        onChange={(e) => onChangeHandler(e.target.value, 'amount')}
                        autoFocus
                        type="number"
                        label={<IntlMessages id="amount" />}
                        variant="outlined" />

                    <Grid container spacing={2} style={{ marginBottom: 20 }}>
                        <Grid item xs={6} ms={6}>
                            <TimePicker
                                value={props.startTime}
                                label={<IntlMessages id="startTime" />}
                                onChange={(value) => onChangeHandler(value, 'startTime')}
                            />
                        </Grid>
                        <Grid item xs={6} ms={6}>
                            <TimePicker
                                value={props.endTime}
                                label={<IntlMessages id="endTime" />}
                                onChange={(value) => onChangeHandler(value, 'endTime')}
                            />
                        </Grid>
                    </Grid>
                    
                    <ButtonGroup variant="text" color="primary" fullWidth>
                        <Button
                            onClick={() => props.setEndRequestFunc()}
                            startIcon={<Close />}>
                            <IntlMessages id="cancel" />
                        </Button>
                        <LoadingButton
                            onClick={() => endRequestFunc()}
                            loading={props.loadingBtn}
                            color="secondary"
                            startIcon={<DoneAll />}>
                            <IntlMessages id="endRequest" />
                        </LoadingButton>
                    </ButtonGroup>
                </Grid>
            </Drawer>
        </React.Fragment >
    )
}

const mapStateToProps = (state) => {
    return {
        list: state.field.list,
        amount: state.field.amount,
        endTime: state.field.endTime,
        startTime: state.field.startTime,
        loadingBtn: state.common.loadingBtn
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setFields: (data) => dispatch(field.setFields(data)),
        completeRequestOrganizationAction: (code) => dispatch(organization.completeRequestOrganizationAction(code))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EndRequest)